import { Dialog, Typography, Grow, IconButton } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

const MainDialogBox = ({
    open,
    handleClose,
    children,
    width,
    heading,
    padding,
    sx,
    mainsx,
    isShowCross = true,
    disableBackdropClick = false,
    disableEscapeKeyDown = false,
    ...props
}) => {
    return (
        <Dialog
            open={open}
            onClose={disableBackdropClick ? undefined : handleClose}
            fullWidth
            maxWidth={false}
            TransitionComponent={Grow}
            disableEscapeKeyDown={disableEscapeKeyDown}
            sx={{
              ...mainsx, 
            }}
            {...props}
            slotProps={{
                paper: {
                    sx: {
                        bgcolor: "#fff",
                        boxShadow: "none",
                        width: { lg: width || "80%", xs: "120%" },
                        maxWidth: { lg: width || "80%", xs: "120%" },
                        borderRadius: "10px",
                        scrollbarWidth: "none",
                        "&::-webkit-scrollbar": { display: "none" },
                        maxHeight: "80vh",
                        p: padding ?? { xs: "10px 15px", sm: "31px 46px" },
                        position: "relative",
                        ...sx,
                    }
                }
            }}
        >
            {isShowCross && (
                <IconButton
                    sx={{
                        position: "absolute",
                        top: 1,
                        right: 1,
                        p: 0.1,
                        borderRadius: "50%",
                        bgcolor: "#fff",
                        "&:hover": { backgroundColor: "#fff" },
                    }}
                    onClick={handleClose}
                >
                    <CloseIcon sx={{ color: "#000", fontSize: "25px" }} />
                </IconButton>
            )}

            {heading && (
                <Typography variant='h5' fontWeight={500} mb={2}>
                    {heading}
                </Typography>
            )}
            {children}
        </Dialog>
    );
};

export default MainDialogBox;
